import React, { useEffect, useState } from 'react'
import EventsListingCard from './EventsListingCard'
import cardImage1 from "../event-view-all-page/image/event-image-1.png"
import cardImage2 from "../event-view-all-page/image/event-image-2.png"
import cardImage3 from "../event-view-all-page/image/event-image-3.png"
import cardImage4 from "../event-view-all-page/image/event-image-4.png"
import hero from "../event-view-all-page/image/hero-img.jpg"

import { FaLocationDot } from "react-icons/fa6";
import './EvenetListingPage.css'

import axios from 'axios';
import { Link } from 'react-router-dom'
import EventsListingCardSkeleton from './EventsListingCardSkeleton'


const url = "https://partywitty.com/master/assets/uploads/";


export default function EvenetListingPage() {

    const [eventsData, setEventData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    const fetchUpcomingEvents = async (lat, lng, date) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('date', date);

            const response = await axios.post(
                'https://partywitty.com/master/APIs/ClubEvent/upcomingEvents',
                formData
            );

            if (response.data.status === true) {
                setEventData(response.data.data); 
            } else {
                console.warn('No events found:', response.data.msg);
                setEventData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setEventData([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, today);
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);


    const eventUrl = (e) => {
        return `/${(e.cityName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.areaName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.clubName?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}/event/${(e.name?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}`;
    };



    return (
        <div className='eventlist-container'>
            <div className="eventlist-hero-section">
                <div className="eventlist-hero-image-wrapper">
                    <img src={hero} alt="Event Banner" className="eventlist-hero-image" />
                    <div className="eventlist-hero-text-overlay">
                        <div className="eventlist-hero-text">
                            <h1>Event Happening Today</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="event-cards-page-container">
                {eventsData.length === 0 ?
                    <>
                        {Array.from({ length: 6 }).map((_, index) => (
                            <EventsListingCardSkeleton key={index} />
                        ))}

                    </>
                    : (
                        eventsData.map((event, index) => (
                            <Link to={eventUrl(event)}>
                                <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer} />
                            </Link>
                        )))}
            </div>
        </div>
    )
}
